import { _ } from "libs";
import React, { memo, useMemo } from "react";
import Select from "../../select";
import { Sport, SelectValues } from "../../../types";

function createValues(sports: Sport[]): SelectValues {
	return sports.map(sport => {
		return {
			label: _(sport.label),
			value: sport.name,
		};
	});
}

function SportSelect({ input: { onChange, value, name }, sports, prompt, ...rest }) {
	const items = useMemo(() => createValues(sports), [sports]);

	return (
		<div className="select sport">
			<Select prompt={prompt} items={items} value={value} onChange={onChange} />
			<div className="icon" />
		</div>
	);
}

export default memo(SportSelect);
